import React, { FunctionComponent } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

export const PageNoServiceLocations: FunctionComponent = () => (
  <CommonError
    title={i18n.page.error.noServiceLocations.title}
    subtitles={[
      i18n.page.error.noServiceLocations.noServiceLocations,
      i18n.page.error.noServiceLocations.waitUntilInstallationIsCompleted,
    ]}
    image={monkeyImageProps}
    dataLayerErrorMessage={DataLayerEcomErrors.NO_SERVICE_LOCATION_ERROR}
  />
);
